
export const TELEGRAM_CHANNEL = 'https://t.me/Bot_PumpFun';
export const TELEGRAM_HANDLE  = '@Bot_PumpFun';
export const TWITTER_URL      = 'https://x.com/PumpSniper_Bot';
